import { useQuery } from "@tanstack/react-query";
import JobService from "../Service.js/jobService";

export const ALL_LISTED_JOBS = "ALL_LISTED_JOBS";
export const useFetchAllListedJobs = (config) => {
  const { params, ...rest } = config;
  const query = useQuery({
    queryKey: [ALL_LISTED_JOBS, params?.limit, params?.offset, params?.search],
    queryFn: async () => {
      const response = await JobService.jobList(params?.limit, params?.offset);
      return response?.data?.data;
    },
    refetchOnWindowFocus: false,
    ...rest,
  });
  return query;
};
